import AppRouter from './AppRouter';

import React from 'react';

export default function Main(props) {
  return (
    <AppRouter />
  );
}
